import useTranslate from 'hooks/useTranslate';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useFollowCompanyMutation, useFollowHashtagMutation } from 'services';
import useAuthStore from 'store/auth';
import useCommonStore, { setModalConfig } from 'store/common';
import useUserStore from 'store/user';
import { decreaseFollowing, increaseFollowing } from 'utils';

interface FollowedBtnProps {
	isFollowed: number; // 0, 1, 2
	id: string;
	className?: string;
	follow: string;
	resData?: any;
	show: boolean;
	setTotalFollowers: any;
}

const FollowBtn: React.FC<FollowedBtnProps> = ({
	isFollowed,
	id,
	className = 'filled-btn rounded-pill lh-1',
	follow,
	resData = {},
	show = false,
	setTotalFollowers = () => {},
}) => {
	const { translate } = useTranslate();
	const { followedHashTags = [], setFollowedHashTags }: Record<string, any> = useUserStore(
		(state) => state,
	);
	const [userFollowed, setUserFollowed] = useState<number>(isFollowed);
	const { hideCommonModal }: any = useCommonStore((state) => state);
	const { mutateAsync: followCompanyMutation } = useFollowCompanyMutation();
	const { mutateAsync: followHashtagMutation } = useFollowHashtagMutation();
	const userDetails: any = useAuthStore((state) => state.userInfo.user);
	const isHash = ['hash']?.includes(follow);
	const unFollowAccount = () => {
		if (!isHash) {
			decreaseFollowing(userDetails?.followings);
		}
		const payload = ['hash']?.includes(follow) ? id : { id: id };
		const apiCalling = ['hash']?.includes(follow) ? followHashtagMutation : followCompanyMutation;

		apiCalling(payload)
			.then((res: any) => {
				if (res?.success) {
					setUserFollowed((prev) => {
						if (isHash) {
							setTotalFollowers((followers: any) =>
								prev === 1 ? Number(followers) - 1 : Number(followers) + 1,
							);
						}
						return prev === 1 ? 0 : 1;
					});
					const hashTagData = followedHashTags.filter((res: any) => res?.id !== id);
					setFollowedHashTags(hashTagData);
				} else {
					if (!isHash) {
						increaseFollowing(userDetails?.followings);
					}
					console.error('Error handling connection request');
				}
			})
			.catch((err: any) => {
				if (!isHash) {
					increaseFollowing(userDetails?.followings);
				}
				console.error('Error:', err);
			})
			.finally(() => {
				hideCommonModal();
			});
	};

	const handleConnectClick = () => {
		const payload = ['hash']?.includes(follow) ? id : { id: id };
		const apiCalling = ['hash']?.includes(follow) ? followHashtagMutation : followCompanyMutation;

		if (userFollowed === 1) {
			setModalConfig({
				visible: true,
				type: 'confirmModal',
				onClick: unFollowAccount,
				data: {
					title: ['hash']?.includes(follow)
						? translate('Modal.wantToUnfollow', { title: `${translate('Modal.hash')}` })
						: translate('Modal.wantToUnfollow', { title: `${translate('Modal.company')}` }),
				},
				props: {
					dialogClassName: 'confirm-modal',
				},
			});
		} else {
			if (!isHash) {
				increaseFollowing(userDetails?.followings);
			}
			apiCalling(payload)
				.then((res: any) => {
					if (res?.success) {
						setUserFollowed((prev) => {
							if (isHash) {
								setTotalFollowers((followers: any) =>
									prev === 1 ? Number(followers) - 1 : Number(followers) + 1,
								);
							}
							return prev === 1 ? 0 : 1;
						});
						const newHashTags = [...followedHashTags, { ...resData, hashTag: resData.name }];
						if (!['comp'].includes(follow)) {
							setFollowedHashTags(newHashTags);
						}
					} else {
						console.error('Error handling connection request');
						if (!isHash) {
							decreaseFollowing(userDetails?.followings);
						}
					}
				})
				.catch((err: any) => {
					if (!isHash) {
						decreaseFollowing(userDetails?.followings);
					}
					console.error('Error:', err);
				});
		}
	};
	if (!show) {
		return;
	}

	return (
		<Button className={`${className} `} onClick={handleConnectClick}>
			{userFollowed === 1 ? translate('Common.unFollow') : translate('Common.follow')}
		</Button>
	);
};

export default FollowBtn;
